// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"350":"d85bc6e4","732":"8d65997a","851":"4e8c69c0"}[chunkId] + ".chunk.css";
};